// extracted by mini-css-extract-plugin
export default {"btn":"btn_btn__UJNDe"};